var _title, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgMove(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 40 40"
  }, props), _title || (_title = /*#__PURE__*/React.createElement("title", null, "cms-move")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20,21.5A1.5,1.5,0,0,1,18.5,20V2.21a1.5,1.5,0,0,1,3,0V20A1.5,1.5,0,0,1,20,21.5Z",
    fill: "#231f20"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.77,7.88a1.5,1.5,0,0,1-.39-2.95,5.15,5.15,0,0,0,3.19-3.16,1.5,1.5,0,0,1,2.86.88,8.14,8.14,0,0,1-5.26,5.18A1.83,1.83,0,0,1,15.77,7.88Z",
    fill: "#231f20"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M24.23,7.88a1.83,1.83,0,0,1-.4,0,8.14,8.14,0,0,1-5.26-5.18,1.5,1.5,0,0,1,2.86-.89,5.05,5.05,0,0,0,3.19,3.17,1.5,1.5,0,0,1-.39,3Z",
    fill: "#231f20"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M20,39.29a1.5,1.5,0,0,1-1.5-1.5V20a1.5,1.5,0,0,1,3,0V37.79A1.5,1.5,0,0,1,20,39.29Z",
    fill: "#231f20"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M20,39.29a1.5,1.5,0,0,1-1.43-1,5.08,5.08,0,0,0-3.19-3.17,1.5,1.5,0,0,1,.79-2.9,8.14,8.14,0,0,1,5.26,5.18,1.49,1.49,0,0,1-1,1.87A1.35,1.35,0,0,1,20,39.29Z",
    fill: "#231f20"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M20,39.28a1.41,1.41,0,0,1-.45-.07,1.48,1.48,0,0,1-1-1.86,8.14,8.14,0,0,1,5.26-5.18,1.5,1.5,0,0,1,.79,2.9,5,5,0,0,0-3.19,3.17A1.51,1.51,0,0,1,20,39.28Z",
    fill: "#231f20"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M20,21.5H2.21a1.5,1.5,0,0,1,0-3H20a1.5,1.5,0,0,1,0,3Z",
    fill: "#231f20"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M6.38,25.73a1.5,1.5,0,0,1-1.45-1.11,5.15,5.15,0,0,0-3.16-3.19,1.5,1.5,0,0,1,.88-2.86,8.14,8.14,0,0,1,5.18,5.26,1.51,1.51,0,0,1-1.06,1.84A1.32,1.32,0,0,1,6.38,25.73Z",
    fill: "#231f20"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M2.21,21.5a1.5,1.5,0,0,1-.45-2.93,5.05,5.05,0,0,0,3.17-3.19,1.5,1.5,0,0,1,2.9.79,8.14,8.14,0,0,1-5.18,5.26A1.31,1.31,0,0,1,2.21,21.5Z",
    fill: "#231f20"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M37.79,21.5H20a1.5,1.5,0,0,1,0-3H37.79a1.5,1.5,0,0,1,0,3Z",
    fill: "#231f20"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M33.62,25.73a1.32,1.32,0,0,1-.39-.06,1.51,1.51,0,0,1-1.06-1.84,8.14,8.14,0,0,1,5.18-5.26,1.5,1.5,0,0,1,.89,2.86,5.08,5.08,0,0,0-3.17,3.19A1.5,1.5,0,0,1,33.62,25.73Z",
    fill: "#231f20"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M37.79,21.5a1.31,1.31,0,0,1-.44-.07,8.14,8.14,0,0,1-5.18-5.26,1.5,1.5,0,0,1,2.9-.79,5,5,0,0,0,3.17,3.19,1.5,1.5,0,0,1-.45,2.93Z",
    fill: "#231f20"
  })));
}

export default SvgMove;